import { cn } from "@/utils/css";

export const LineChartTooltip = ({ x, y, value, visible, maxValue, minValue }) => {
    const hasMinMax = maxValue && minValue;
    const isValidPosition = isFinite(x) && isFinite(y);

    return (
        <div
            className={cn(
                "flex flex-col absolute pointer-events-none bg-cm-p-container-green rounded-lg  text-right drop-shadow-[0_2px_4px_rgba(0,0,0,0.06)]",
                {
                    "w-[88px] h-[72px] pt-1 pb-[6px] px-3": hasMinMax,
                    "w-[60px] h-[30px] py-1 px-2": !hasMinMax,
                },
            )}
            style={{ left: isValidPosition ? x : 0, top: isValidPosition ? y : 0, opacity: visible && isValidPosition ? 1 : 0 }}
        >
            <div className="text-sm/[22px] text-cm-p-text-primary font-semibold">$ {value}</div>
            {minValue && <div className="text-xs/[19px] text-cm-p-text-primary">min {minValue}</div>}
            {maxValue && <div className="text-xs/[19px] text-cm-p-text-primary">max {maxValue}</div>}
        </div>
    );
};
